module.exports = __webpack_public_path__ + "static/media/grand_mother_and_friends_smiling.cfb9446f.png";